import request from './adminRequest'

export const mentorApi = {
  listMentor (params) {
    return request.get('/mentors', { params: params })
  },
  getMentor (uid) {
    return request.get('/mentors/' + uid)
  },
  updateMentor (uid, data) {
    return request.put('/mentors/' + uid, data)
  },
  deleteMentor (uid) {
    return request.delete('/mentors/' + uid)
  },
}
export default mentorApi
